import { render, staticRenderFns } from "./batchCreate.vue?vue&type=template&id=0549030a&"
import script from "./batchCreate.vue?vue&type=script&lang=js&"
export * from "./batchCreate.vue?vue&type=script&lang=js&"
import style0 from "./batchCreate.vue?vue&type=style&index=0&id=0549030a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports